module.exports = __webpack_public_path__ + "static/media/song2.caf58c23.mp3";